import { ApiError, apiRequest } from "./apiClient";

let csrfToken;

export async function getCsrfToken(forceRefresh = false) {
  if (csrfToken && !forceRefresh) {
    return csrfToken;
  }

  const result = await apiRequest("/api/auth/csrf");

  if (!result?.token) {
    throw new Error("The backend did not return a CSRF token");
  }

  csrfToken = result.token;
  return csrfToken;
}

export async function stateChangingRequest(path, options = {}) {
  const token = await getCsrfToken();

  try {
    return await apiRequest(path, {
      ...options,
      headers: {
        ...options.headers,
        "X-XSRF-TOKEN": token,
      },
    });
  } catch (error) {
    if (!(error instanceof ApiError) || error.status !== 403) {
      throw error;
    }

    const refreshedToken = await getCsrfToken(true);
    return apiRequest(path, {
      ...options,
      headers: {
        ...options.headers,
        "X-XSRF-TOKEN": refreshedToken,
      },
    });
  }
}

export function login(email, password) {
  return stateChangingRequest("/api/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
}

export function beginTwoFactorSetup() {
  return stateChangingRequest("/api/auth/2fa/setup", { method: "POST" });
}

export function verifyTwoFactorCode(code, purpose = "challenge") {
  const endpoint = purpose === "enable" ? "enable" : "challenge";
  return stateChangingRequest(`/api/auth/2fa/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
}

export function recoverTwoFactor(recoveryPhrase) {
  return stateChangingRequest("/api/auth/2fa/recovery", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ recoveryPhrase }),
  });
}

export function disableTwoFactor(currentPassword, code) {
  return stateChangingRequest("/api/auth/2fa/disable", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ currentPassword, code }),
  });
}

export async function getCurrentUser() {
  try {
    return await apiRequest("/api/auth/me");
  } catch (error) {
    if (
      error instanceof ApiError &&
      (error.status === 401 || error.status === 403)
    ) {
      console.log("User not logged in");
      return null;
    }

    throw error;
  }
}

export function logout() {
  return stateChangingRequest("/api/auth/logout", {
    method: "POST",
  });
}

export function changeOwnPassword(currentPassword, newPassword) {
  return stateChangingRequest("/api/auth/password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
}

export function changeRequiredPassword(newPassword) {
  return stateChangingRequest("/api/auth/password/required", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ newPassword }),
  });
}
